import { ChangeDetectionStrategy, Component, computed, effect, inject, input, OnDestroy, output, TemplateRef, viewChild } from '@angular/core';
import { ShowToastResult } from '@siemens/ix-angular';
import { ToastService, IxButton } from '@siemens/ix-angular/standalone';
import { DateSDPipe } from '../../pipes/date-sd.pipe';

@Component({
  selector: 'login-expiration-warning',
  imports: [DateSDPipe, IxButton],
  template: `
  <ng-template #customToast let-toast>
      <div>
        <div>You login expires at {{time() ?? "" | date: 'medium'}} and can not be extended please logout and log in again.</div>
        <ix-button [variant]="'danger'" (click)="buttonClicked()">Logout</ix-button>

      </div>
    </ng-template>`,
  styleUrl: './login-expiration-warning.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginExpirationWarningComponent implements OnDestroy {

  expirationTime = input.required<Date | undefined>();
  logout = output<void>();

  ngOnDestroy(): void {
    this.toast?.close()
  }
  customToastRef = viewChild<TemplateRef<unknown>>('customToast');
  readonly #toastService = inject(ToastService);

  toast?: ShowToastResult

  buttonClicked() {
    this.logout.emit();
    this.toast?.close();
  }

  time = computed(() => {
    const expirationTime = this.expirationTime();
    if (!expirationTime) {
      return undefined;
    }
    return expirationTime.toISOString();
  })

  eff1 = effect(() => {
    const time = this.expirationTime();
    if (this.customToastRef() && time) {
      this.showToastMessage();
    }
  });

  async showToastMessage() {
    this.toast = await this.#toastService.show({
      message: this.customToastRef()!,
      autoClose: false,
      type: 'warning',
    });
  }
}
